import WrapContent from "./WrapContent";

export default WrapContent;
